import React from 'react'
import { withTranslation } from 'react-i18next'
import Slider from 'react-slick'

// import { IconPrevArr, IconNextArr } from '../svg'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Link } from 'react-router-dom'

class TemplatesCarousel extends React.Component {
    render() {
        const { items, isTrial, getUseLayoutButton, t } = this.props

        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 1870,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: true,
                    },
                },
                {
                    breakpoint: 1078,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        }

        return (
            <Slider className="templates-carousel" {...settings}>
                {items.map(item => {
                    return (
                        <div className="slide-wrap" key={item.id}>
                            <div className="prev-box">
                                <img src={item.projectImage} alt="" />
                            </div>
                            <div className="btns">{getUseLayoutButton(item, isTrial)}</div>
                        </div>
                    )
                })}
            </Slider>
        )
    }
}

export default withTranslation('translations')(TemplatesCarousel)
